import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { Grid, Typography, FormGroup, Tooltip, Collapse } from '@mui/material';

import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';

import ArtistDashboardEventCard from '../events/ArtistDashboardEventCard';

import Button from '../layout/SvgButton';

const PastArtistEvents = ({ hostMe, myArtistEvents, iConfirmed }) => {
    const location = useLocation();
    const [showPastEvents, setShowPastEvents] = useState(false);
    const [userCollapsed, setUserCollapsed] = useState(false);

    const dayBeforeYesterday = new Date();
    dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2);

    const isPastArtistEvent = (myEvent) =>
        myEvent.confirmedHost &&
        myEvent.status === 'CONFIRMED' &&
        iConfirmed(myEvent) &&
        new Date(myEvent.bookingWhen) < dayBeforeYesterday;

    const pastArtistEvents = (
        Array.isArray(myArtistEvents) ? myArtistEvents : []
    )
        .filter(isPastArtistEvent)
        .sort((a, b) => {
            const aTime = new Date(a?.bookingWhen || 0).getTime();
            const bTime = new Date(b?.bookingWhen || 0).getTime();
            return bTime - aTime; // most recent first
        });

    const queryEventID = new URLSearchParams(location.search).get('eventID');
    const queryTargetsPast =
        Boolean(queryEventID) &&
        pastArtistEvents.some(
            (myEvent) => String(myEvent._id) === String(queryEventID)
        );
    const pastOpen = userCollapsed
        ? false
        : Boolean(showPastEvents || queryTargetsPast);

    useEffect(() => {
        if (myArtistEvents && myArtistEvents.length > 0) {
            const unReviewedEvents = myArtistEvents.forEach((myArtistEvent) => {
                if (
                    myArtistEvents.filter(
                        (myEvent) =>
                            isPastArtistEvent(myEvent) &&
                            (!myEvent.artistReviewOfHost ||
                                !myEvent.artistReviewOfHost._id)
                    ).length > 0
                ) {
                    setShowPastEvents(true);
                }
            });
        }
    }, [myArtistEvents]);

    useEffect(() => {
        const eventID = new URLSearchParams(location.search).get('eventID');
        if (!eventID || !myArtistEvents || myArtistEvents.length === 0) return;
        const targetsPast = myArtistEvents.some(
            (myEvent) =>
                isPastArtistEvent(myEvent) &&
                String(myEvent._id) === String(eventID)
        );
        if (targetsPast) {
            setShowPastEvents(true);
            setUserCollapsed(false);
        }
    }, [location.search, myArtistEvents]);

    return (
        <>
            {pastArtistEvents.length > 0 && (
                <>
                    <Typography
                        onClick={() => {
                            if (pastOpen) {
                                setUserCollapsed(true);
                                setShowPastEvents(false);
                            } else {
                                setUserCollapsed(false);
                                setShowPastEvents(true);
                            }
                        }}
                        sx={{
                            color: 'var(--link-color)',
                            cursor: 'pointer',
                            margin: pastOpen
                                ? '16px 16px 0px 16px'
                                : '16px 16px 16px 16px',
                            textAlign: 'center',
                            transition: 'margin 0.3s ease-in-out',
                        }}
                    >
                        {pastOpen ? 'Hide Past Events' : 'Show Past Events'}
                    </Typography>
                    <Collapse
                        in={pastOpen}
                        timeout={300}
                        sx={{
                            overflow: 'visible',
                            '& .MuiCollapse-wrapper': {
                                overflow: 'visible',
                            },
                            '& .MuiCollapse-wrapperInner': {
                                overflow: 'visible',
                            },
                        }}
                    >
                        <Grid
                            container
                            direction="column"
                            sx={{
                                marginBottom: '20px',
                                marginTop: showPastEvents ? '0px' : '-20px',
                                transition: 'margin 0.3s ease-in-out',
                            }}
                        >
                            <Grid item>
                                <Typography component="h2">
                                    {pastArtistEvents.length > 1
                                        ? `You booked these ${pastArtistEvents.length} concerts, in the past`
                                        : `You booked this concert, in the past`}
                                    :
                                </Typography>
                            </Grid>
                            {/* {bookingWhenWhere && bookingWhenWhere.length > 0 && bookingWhenWhere[0].when ? //check to be sure there's a valid first entry */}
                            <Grid
                                container
                                className="whenBooking"
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                                sx={{
                                    margin: '0px auto 16px',
                                    width: '100%',
                                }}
                            ></Grid>
                            {pastArtistEvents.map(
                                (thisEvent, idx) =>
                                    thisEvent.bookingWhen &&
                                    thisEvent.bookingWhere && (
                                        <ArtistDashboardEventCard
                                            key={idx}
                                            thisEvent={thisEvent}
                                        />
                                    )
                            )}
                        </Grid>
                    </Collapse>
                </>
            )}
        </>
    );
};

PastArtistEvents.propTypes = {
    artist: PropTypes.object,
    myArtistEvents: PropTypes.array,
    iConfirmed: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    artist: state.artist,
    myArtistEvents: state.event.myArtistEvents,
});

export default connect(mapStateToProps, {})(PastArtistEvents);
